import { Box, HStack, Image, Spinner, Text, VStack } from "native-base";
import MobileHeader from "../../../../layout/header/mobileHeader";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import { COLORS } from "../../../../utils/colors";
import config from "../../../../utils/config";

const MobileRequestEventBanner = ({ bannerPath = [], isLoading = false }) => {
  function bannerText() {
    return (
      <VStack alignItems={"center"} justifyContent={"center"} px={4}>
        <Text
          fontSize={"24px"}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          pt={2}
          textAlign={"center"}
        >
          Welcome to ABG MICE & Events
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          textAlign={"center"}
          mb={4}
        >
          This is a all in one platform where you can view all your events and
          MICE.
        </Text>
        {/* <CustomButton
          onPress={() => {
            openModal();
          }}
          text="Raise Request"
          width="fit-content"
          py="10px"
        /> */}
      </VStack>
    );
  }
  return (
    <Box bg={COLORS.WHITE_COLOR}>
      <MobileHeader />
      {isLoading ? (
        <Box
          mt={5}
          mb={10}
          flex={1}
          alignItems="center"
          justifyContent="center"
          minH={"180px"}
          height="180px"
        >
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : bannerPath.length === 0 ? (
        <div className="request-detail-page-banner" p={"20px"}>
          <div className="landing-page-banner-container">
            <HStack flex={1} w="100%" h="100%" direction={"column"}>
              <Box w={"100%"} alignItems={"center"} pt={5}>
                <Image
                  source={{
                    uri: require("../../../../utils/quickLinkImages/landing-page-banner.png"),
                  }}
                  alt="image"
                  width="200px"
                  minH="180px"
                />
              </Box>
              <Box w={"100%"} pt={6} pb={"2rem"}>
                {bannerText()}
              </Box>
            </HStack>
          </div>
        </div>
      ) : (
        <Box minH={"180px"} height={"180px"}>
          <Image
            source={{
              uri: config.bucketPath + bannerPath?.[0]?.file_name,
            }}
            alt="image"
            width="100%"
            height="100%"
            resizeMode="stretch"
          />
        </Box>
      )}
    </Box>
  );
};

export default MobileRequestEventBanner;
